import { timeZoneWord } from '@/shared/lib/timeZoneWord';
import { ResourceDayPicker } from './ResourceDayPicker';

/** Kopf der Ressourcenkarte: Tagwahl, wie gebucht wird, Zeitzone des Objekts. */
export function ResourceDayHeader({
  days,
  day,
  timezone,
  canDrag,
  onDay,
}: {
  days: string[];
  day: string;
  timezone: string;
  canDrag: boolean;
  onDay: (day: string) => void;
}) {
  return (
    <div className="border-hairline flex flex-wrap items-center gap-x-2.5 gap-y-1.5 border-b px-3 py-3.5 md:px-[18px]">
      <ResourceDayPicker days={days} value={day} onChange={onDay} />
      <span className="text-ink-soft text-[13px]">
        Halbstündlich buchbar.{canDrag ? ' Ziehen markiert eine Zeit.' : ''} Zeitzone:{' '}
        {timeZoneWord(timezone)}.
      </span>
    </div>
  );
}
